import { AxiosError, AxiosResponse } from "axios"
import api from "../../../data/api"
import { Dispatch } from "react"
import { prepareError, prepareErrorFromArray } from "../../../utils/error"
import { objectFormData } from "../../../utils/formdata"
import { Security } from "../../../openapi/security/api"
import { SecurityAction } from "../result/reducer"

// search for Securities  ///codelist/v1/SecurityLuxCSD/search  ///codelist/v1/Security/search
export const fetchSecurities = (
    dispatch: Dispatch<SecurityAction>,
    data: FormData,
    inpWindowHistoryState: Object
) => {        
    dispatch({type: "SecurityResult/SAVEHISTORY", windowHistoryState: inpWindowHistoryState});
    api
    .post("/codelist/luxcsd/v1/SecurityLuxCSD/search",  objectFormData(data)  ) 
    .then( (response:AxiosResponse) => {
        if ( response.data.result && response.data.result === "ERROR") {
            dispatch({ type: "Security/FETCHERROR", payload: prepareErrorFromArray(response.data.errorMessage, "Error") })
        }  else if (response.data.result && response.data.result === "REJECTED") {
            dispatch({ type: "Security/FETCHERROR", payload: "For selected search criteria no data has been found." })            
        } else {                  
            const securities : Security[] = response.data.securityList;               
            dispatch({type: "Security/SEARCHDONE", payload: securities, searchCriteria: data})
            dispatch({ type: "Security/FETCHERROR", payload: "" })
        }            
    }).catch( (error:AxiosError) => {
        dispatch({ type: "Security/FETCHERROR", payload: prepareError(error) })           
    })
}
